import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';

export function ReservationsAssetsBundleTable() {
  const assets_bundle = [
    {
      amount_free_resevations_in: 5,
      base_model_type: 'controlnet_model',
      version: '3.1',
      size_on_disk: 300,
      using_times_last_30_days: 12,
    },
    {
      amount_free_resevations_in: 3,
      base_model_type: 'controlnet_model',
      version: '3.2',
      size_on_disk: 310,
      using_times_last_30_days: 20,
    },
    {
      amount_free_resevations_in: 1,
      base_model_type: 'controlnet_model',
      version: '3.3',
      size_on_disk: 320,
      using_times_last_30_days: 25,
    },
    {
      amount_free_resevations_in: 0,
      base_model_type: 'controlnet_model',
      version: '4.0',
      size_on_disk: 330,
      using_times_last_30_days: 8,
    },
  ];
  /*
   * HTML
   */

  function render_header() {
    return (
      <div className="px-2 w-full flex h-[40px] items-center justify-end gap-2 border-b-2 border-dashed border-component-border">
        <div className="w-[50px] overflow-hidden"></div>
        <div className="w-[150px] overflow-hidden">version</div>
        <div className="w-[150px] overflow-hidden">size_on_disk</div>
        <div className="w-[150px] overflow-hidden">using_times_last_30_days</div>
        <div className="w-[150px] overflow-hidden">base_model_type</div>
        <div className="w-[150px] overflow-hidden">amount_free_resevations_in</div>
      </div>
    );
  }

  function render_rows() {
    return assets_bundle.map(asset => {
      return render_row(asset);
    });
  }

  function render_row(row: any) {
    return (
      <div key={row.hash} className="px-2 w-full h-[40px] flex gap-2 items-center justify-start border rounded-lg border-component-border ">
        <div className="w-[50px] overflow-hidden">
          <UI_PRIMITIVE__checkbox checked={false} onCheckedChange={() => {}} disabled={false} />
        </div>
        <div className="w-[150px] overflow-hidden">{row.version}</div>
        <div className="w-[150px] overflow-hidden">{row.size_on_disk}</div>
        <div className="w-[150px] overflow-hidden">{row.using_times_last_30_days}</div>
        <div className="w-[150px] overflow-hidden">{row.base_model_type}</div>
        <div className="w-[150px] overflow-hidden">{row.amount_free_resevations_in}</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      {render_header()}

      <div className="relative overflow-auto h-full flex flex-col gap-2">{render_rows()}</div>
    </div>
  );
}
